import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathGreaterThan: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="math-greater-than, >"><path fillRule="evenodd" clipRule="evenodd" d="M5.05853 6.45977C5.21892 6.07787 5.65854 5.89831 6.04044 6.05871L18.5404 11.3087C18.8189 11.4257 19 11.6982 19 12.0002C19 12.3022 18.8189 12.5747 18.5404 12.6917L6.04044 17.9417C5.65854 18.1021 5.21892 17.9225 5.05853 17.5406C4.89813 17.1587 5.07769 16.7191 5.45959 16.5587L16.3132 12.0002L5.45959 7.44168C5.07769 7.28128 4.89813 6.84167 5.05853 6.45977Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMathGreaterThan;
